import { Outlet, createFileRoute } from "@tanstack/react-router";

import { PermissionGuard } from "~/components/permission-guard";

export const Route = createFileRoute("/_dash/basecamp/evals")({
  component: () => (
    <PermissionGuard permission="evals:view">
      <Outlet />
    </PermissionGuard>
  ),
});
